var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowFatDown = function SvgIconArrowFatDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.013 3.263A1.75 1.75 0 0 1 8.25 2.75h7.5A1.75 1.75 0 0 1 17.5 4.5v7.25H21a1 1 0 0 1 .707 1.707l-9 9a1 1 0 0 1-1.414 0l-9-9A1 1 0 0 1 3 11.75h3.5V4.5c0-.464.184-.91.513-1.237M8.5 4.75v8a1 1 0 0 1-1 1H5.414L12 20.336l6.586-6.586H16.5a1 1 0 0 1-1-1v-8z",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowFatDown;